export default __webpack_public_path__ + "static/media/powered-by-goopter-color.77fa319c.svg";